import React, {useEffect} from 'react';

import Transition from '../assets/Transition';
import Header from '../components/Header';
import Person from '../components/People/Person';
import About from "../components/About";
import ContactForm from "../components/ContactForm";


import Image from '../assets/team.webp';
import people from '../components/People/PeopleList.json';

const Team = () => {
    useEffect(() => {
        document.title = "About Me";
    });
    
    return (
        <div>
            <Header
                title="About Nick"
                tagline={ <>Building software that solves <span className='underline'>real</span> business problems.</> } 
                image={Image}
                subtitle="ZOTY UNITED" />
            <section className="people">
                {people.map((person, index) => {
                    return <Person person={person} key={index} />
                })}
            </section>
            <About />
            <ContactForm />
        </div>
    );
};

export default Transition(Team);